import { IMultiSelectFilterItem } from "components/filters/MultiSelectFilter";
import { immerable } from "immer";

export class StoreSize implements IMultiSelectFilterItem {
    [immerable] = true;

    private _isSelected: boolean;
    public readonly id: string;
    public readonly name: string;

    constructor(
        name: string,
        isSelected: boolean
    ) {
        this.id = name;
        this.name = name;
        this._isSelected = isSelected;
    }

    isSelected() {
        return this._isSelected;
    }

    setIsSelected(isSelected: boolean) {
        this._isSelected = isSelected;
    }

    toggleIsSelected() {
        this._isSelected = !this._isSelected;
    }
}
